<template>
  <span>
    <DialogSourceFilterStringMeterUnit
      v-if="valueFilter == false"
      :source_id="meter_unit._source.id"
      :project="project"
      :dialog.sync="dialog"
      :sourceFilterString.sync="item[slotData.form.name || slotData.name]"
      :sourceFilterType.sync="
        item[slotData.form.sourceFilterType || slotData.sourceFilterType]
      "
      :resource="slotData.form.options && slotData.form.options.resource"
      :store="slotData.form.options && slotData.form.options.store"
      :code-item-key="
        slotData.form.options && slotData.form.options.codeItemKey
      "
    ></DialogSourceFilterStringMeterUnit>
    <DialogValueFilterStringIngestion
      v-else
      :project="project"
      :dialog.sync="dialog"
      :valueFilter.sync="item[slotData.form.name || slotData.name]"
      :filterType.sync="item[slotData.form.filterType || slotData.filterType]"
      :filterLabel.sync="
        item[slotData.form.filterLabel || slotData.filterLabel] ||
          slotData.form.filterLabel
      "
      :resource="slotData.form.options && slotData.form.options.resource"
      :store="slotData.form.options && slotData.form.options.store"
      :code-item-key="
        slotData.form.options && slotData.form.options.codeItemKey
      "
    ></DialogValueFilterStringIngestion>
    <v-text-field
      v-bind:key="slotData.name"
      v-model="item[slotData.form.name || slotData.name]"
      :placeholder="$t(`${resource}.${slotData.title || slotData.name}`)"
      :rules="[
        ...(slotData.form.rules || []),
        backEndValidation(slotData.form.name || slotData.name)
      ]"
      :type="slotData.form.input_type || 'text'"
      :suffix="
        item[slotData.decorator || ''] || slotData.decoratorDefault || ''
      "
      append-outer-icon="mdi-pencil"
      v-on:click:append-outer="() => (dialog = true)"
    ></v-text-field>
  </span>
</template>
<script>
import DialogSourceFilterStringMeterUnit from "../../../projects/metering/meter-units/DialogSourceFilterStringMeterUnit";
import DialogValueFilterStringIngestion from "../../../projects/metering/ingestions/DialogValueFilterIngestion";
import { rules } from "../../../mixins/rules";

export default {
  name: "SourceFilterStringFormItem",
  components: {
    DialogSourceFilterStringMeterUnit,
    DialogValueFilterStringIngestion
  },
  data: () => ({
    dialog: false
  }),
  props: {
    resource: {
      type: String
    },
    slotData: {
      type: Object
    },
    item: {
      type: Object
    },
    valueFilter: {
      type: Boolean,
      default: false
    }
  },
  mixins: [rules],
  computed: {
    meter_unit: {
      get() {
        return this.$store.getters[
          "projectMeteringStore/meterUnitStore/getItem"
        ];
      }
    },
    project() {
      return this.$store.getters["projectStore/getCurrentItem"];
    }
  },
  watch: {},
  mounted() {}
};
</script>

<style scoped>
span {
  display: flex;
}
</style>
